// ====================================================================================
// scrollytellingVideo.module.js
// ====================================================================================

const bgVideos = document.querySelectorAll(".scrollytelling-page .bg-video");
const videoSources = [];

export const init = () => {
  bgVideos.forEach((video) => {
    let videoSource = video.getAttribute("data-src");
    if (videoSource && videoSources.indexOf(videoSource) === -1) {
      videoSources.push(videoSource);
    }
  });

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      videoSources.forEach((videoSource) => {
        let video = document.createElement("video");
        video.width = 1920;
        video.height = 1080;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.muted = true;
        video.classList.add("background", "video");
        let sourceElem = document.createElement("source");
        sourceElem.src = videoSource;
        sourceElem.type = "video/mp4";
        video.appendChild(sourceElem);

        let idx = 0;
        bgVideos.forEach((srcVideo, index) => {
          let parent = srcVideo.parentElement;
          let elSource = srcVideo.getAttribute("data-src");
          if (elSource === videoSource) {
            if (index === 0) {
              parent.appendChild(video);
            } else {
              let canvas = document.createElement("canvas");
              canvas.classList.add("background", "video");
              canvas.width = 1920;
              canvas.height = 1080;
              parent.appendChild(canvas);

              const interval = setInterval(() => {
                if (!video.paused && !video.ended) {
                  canvas.getContext("2d").drawImage(video, 0, 0);
                } else {
                  video.play();
                }
              }, 1000 / 30);
              // clearInterval(interval);
            }
            idx++;
          }
        });
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
